import React, { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HOST_API } from "src/config";

const InternetConnectionContext = createContext({ isConnected: true });

InternetConnectionProvider.propTypes = {
  children: PropTypes.node,
};

function InternetConnectionProvider({ children }) {
  const [internetStatus, setInternetStatus] = useState(false);

  useEffect(() => {
    const checkInternetConnectivity = async () => {

      const controller = new AbortController();

      setTimeout(() => controller.abort(), 2000);

      try {
        await fetch(`${HOST_API}api/connection`, {
          headers: {
            "Accept": "application/json",
            "accessToken": process.env.REACT_APP_ACCESS_TOKEN
          }
        });
        setInternetStatus(true);
      } catch (error) {
        setInternetStatus(false);
      }
    };

    const interval = setInterval(checkInternetConnectivity, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <InternetConnectionContext.Provider
      value={{
        isConnected: internetStatus,
      }}
    >
      {children}
    </InternetConnectionContext.Provider>
  );
}

export { InternetConnectionProvider, InternetConnectionContext };
